import Subject from "../cse4sub/Subject";
import React from 'react'

export default function FmLab() {
  return (
    <div>
       <Subject title="Fluid Mechanics Lab(AE303)" book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}